<template>
  <pt-system-user-detail class="pt-system-user-detail__page"></pt-system-user-detail>
</template>

<script>
import PtSystemUserDetail from 'cps/customer-manage/pt-system-user-detail/withData'
export default {
  name: 'pt-system-user-detail__view',
  components: {
    'pt-system-user-detail': PtSystemUserDetail
  }
}
</script>
